import { connect } from 'react-redux';
import { PostRequestModal } from '../common';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'switchPlanMode'),
});

export default connect(mapStateToProps)(PostRequestModal);
